import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const LogoImage = styled.img`
  width: 60px;
  object-fit: scale-down;
  
  &:first-child {
    margin-right: 2rem;
  }
  ${breakpoint('tablet')`
    width: 80px;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/Logo/styledComponents.js